import { h, render } from "preact";
import BookingCalculation from "./booking-calculator";
import { initCapacityAdaptation } from "./capacity-adaptation";

export function initBookingCalculator() {
  const bcWrap = document.getElementById("booking-calculation");
  if (!bcWrap || bcWrap.dataset.calculatorMounted === "1") {
    return;
  }

  render(h(BookingCalculation, { bcWrap }), bcWrap);
  bcWrap.dataset.calculatorMounted = "1";
  window.__p4gBookingCalculatorMounted = true;

  const availabilityForm = document.getElementById("availability-form");
  if (availabilityForm) {
    initCapacityAdaptation(availabilityForm);
  }
  const inquiryForm = document.getElementById("inquiry-form");
  if (inquiryForm) {
    initCapacityAdaptation(inquiryForm);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBookingCalculator);
} else {
  initBookingCalculator();
}
